import {
    all,
    fork,
    takeLatest,
    take,
    cancelled,
    race,
    put,
    select
} from 'redux-saga/effects';

import { GET_USER_COLLECTION, LOGOUT_USER, SET_ACTIVE_USER_ORG } from '../actions/types';

import { eventChannel } from 'redux-saga';

import { db, fsTools } from 'config/firebase';

import { storeUserCollection } from '../actions/User';
import { settingActiveOrgSuccess } from '../actions/Org';
import {
    activeOrgCollectionWatch,
    orgCollectionWatch,
    orgInvitesV2CollectionWatch
} from './Org';
import { getOrgKiosks } from './Panels';
import { otcCollectionWatch } from './Otc';

import { log } from 'utils/Loggers';
import { reservationsCollectionWatch } from './Reservations';
import { propertyCollectionWatch, orgPropertiesCollectionWatch } from './Properties';
import { startAccessLogsLive } from './AccessLogs';
import { guestLikeRoles, userRoles, userTypes } from 'utils/constants';
import { _userData, _orgs } from './Selectors';
import { notificationsSaga } from './Notifications';
import { withActiveContext } from 'utils/app-context';

export function* userCollectionWatch(user) {
    let unsubcscribeUserCollectionData;
    const userCollectionChannel = eventChannel(emit => {
        const usersRef = fsTools.doc(db, 'users', user.uid);

        unsubcscribeUserCollectionData = fsTools.onSnapshot(usersRef, doc => {
            if (doc) {
                // Someone who is both a team member and a resident reads as the app they are in.
                emit(withActiveContext(doc.data()));
            } else {
                doc = { exists: false };
                emit({ doc });
            }
        });
        return unsubcscribeUserCollectionData;
    });
    try {
        while (true) {
            const { userSignOut, resettingOrg, userCollectionData } = yield race({
                userSignOut: take(LOGOUT_USER),
                resettingOrg: take(SET_ACTIVE_USER_ORG),
                userCollectionData: take(userCollectionChannel)
            });

            if (userSignOut) {
                userCollectionChannel.close(); // Detach saga event emitter
            } else if (resettingOrg) {
                console.log('* Executing New Org Focus *');
                console.log(``);
            } else {
                const userData = yield select(_userData);
                const orgs = yield select(_orgs);

                if (userData) {
                    if (userData.active_org_id !== userCollectionData.active_org_id) {
                        console.log(
                            '* [Reinitializing] * - Refocused to a new Org/Previous Listeners have been cancelled and they need to be reinitialized'
                        );
                        console.log(
                            `Previous user data active org id: ${userData?.active_org_id}`
                        );
                        console.log(
                            `Updated user data active org id: ${userCollectionData.active_org_id}`
                        );
                        console.log(``);

                        if (orgs) {
                            const latestActiveOrg = orgs.filter(
                                org => org.org_id === userCollectionData.active_org_id
                            )[0];
                            // console.log(
                            //     '[Reinitializing] - Sending latest active org id changed from firestore doc to now help point to new active org from initial all orgs listener and also updates activePermissions of the user who is pointing to new active org'
                            // );
                            yield put(
                                settingActiveOrgSuccess(userCollectionData.active_org_id)
                            );
                            // const activeOrg = yield select(_activeOrg);
                            // console.log(activeOrg, 'heyyyyyyyyyyyyyyy');
                            // console.log(
                            //     '[Reinitializing] - Restarting Org RTDB Data Listener'
                            // );
                            yield fork(activeOrgCollectionWatch, {
                                payload: {
                                    id: userCollectionData.active_org_id,
                                    userType: userCollectionData.type
                                }
                            });

                            // console.log(
                            //     '[Reinitializing] - Operator getting RTDB CAPanels and RTDB OrgDevices'
                            // );
                            yield fork(getOrgKiosks, userCollectionData);

                            // console.log(
                            //     '[Reinitializing] - Restarting Org Properties Collection Listener'
                            // );

                            yield fork(orgPropertiesCollectionWatch, {
                                payload: { ...latestActiveOrg }
                            });

                            // console.log(
                            //     '[Reinitializing] - Restarting Org Invites Collection Listener'
                            // );

                            yield fork(orgInvitesV2CollectionWatch, {
                                payload: { ...latestActiveOrg }
                            });

                            // console.log(
                            //     '[Reinitializing] - Restarting Org OTC Collection Listener'
                            // );
                            yield fork(
                                otcCollectionWatch,
                                latestActiveOrg.org_id,
                                latestActiveOrg.property_id
                            );

                            // console.log(
                            //     '[Reinitializing] - Restarting Org Reservations Collection Listener'
                            // );

                            yield fork(reservationsCollectionWatch, {
                                payload: latestActiveOrg.org_id
                            });

                            if (
                                userCollectionData.role === userRoles.OPERATOR ||
                                userCollectionData.type === userTypes.SUPER_ADMIN
                            ) {
                                yield fork(startAccessLogsLive, latestActiveOrg.org_id);
                            }
                        }
                    } else {
                        console.log(
                            'Do nothing to restart any listeners cause active org id is the same though user doc updated'
                        );
                    }
                    console.log(
                        '* [Reinitializing] * - Listeners reinitialized and finally updating user data in reducer referencing newly focused org'
                    );
                    console.log(``);
                    yield put(storeUserCollection(userCollectionData));
                } else {
                    console.log(
                        '* [INITIAL] * - User data does not exist yet so start initial listeners based on Role Type and users current Active Org'
                    );
                    console.log(
                        `Previous user data active org: ${userData?.active_org_id}`
                    );
                    console.log(
                        `Initial Live Listened user data active org: ${userCollectionData.active_org_id}`
                    );
                    console.log(`User Role Type: ${userCollectionData.role}`);
                    console.log(``);

                    yield put(storeUserCollection(userCollectionData));

                    if (
                        userCollectionData.role === userRoles.RESIDENT ||
                        userCollectionData.role === userRoles.TENANT ||
                        guestLikeRoles.includes(userCollectionData.role) ||
                        userCollectionData.role === userRoles.OPERATOR
                    ) {
                        yield fork(notificationsSaga);
                    }
                    /**
                     *
                     * Resi
                     * !Guest
                     * Operator
                     * Super Admin
                     *
                     */

                    if (!guestLikeRoles.includes(userCollectionData.role)) {
                        // console.log(
                        //     '[INITIAL] - Starting Firestore Orgs and Active Org RTDB (based on active_org_id) Listeners'
                        // );
                        yield fork(orgCollectionWatch, userCollectionData);
                        yield fork(activeOrgCollectionWatch, {
                            payload: {
                                id: userCollectionData.active_org_id,
                                userType: userCollectionData.type
                            }
                        });
                    }

                    if (
                        userCollectionData.role === 'resi' ||
                        (userCollectionData.role === 'tenant' &&
                            userCollectionData.type === 'long-term')
                    ) {
                        // console.log(
                        //     '[INITIAL] - Starting resi/tenant active property Listener'
                        // );
                        if (userCollectionData.active_property_id) {
                            yield fork(propertyCollectionWatch, {
                                propertyId: userCollectionData.active_property_id
                            });
                        }

                        return;
                    }

                    if (
                        userCollectionData.role === 'operator' &&
                        userCollectionData.type !== 'super_admin'
                    ) {
                        yield fork(getOrgKiosks, userCollectionData);
                    }

                    // console.log('[INITIAL] - Starting Reservations Collection Listener');

                    yield fork(reservationsCollectionWatch, {
                        payload: userCollectionData.active_org_id
                            ? userCollectionData.active_org_id
                            : userCollectionData.primary_org
                    });

                    if (
                        userCollectionData.active_org_id &&
                        (userCollectionData.role === userRoles.OPERATOR ||
                            userCollectionData.type === userTypes.SUPER_ADMIN)
                    ) {
                        yield fork(startAccessLogsLive, userCollectionData.active_org_id);
                    }
                }

                /**
                 *
                 * Check 1...is there is userData? if not then app is fresh and initializing so run through all live listeners needed
                 * according to type
                 *
                 * if there is data then determine what should be run through again and leave already started listeners alone unless
                 * focused org is switched..then make sure reset is killing previous listeners and let them refresh here in this condition
                 *
                 * set active org data based on what the active org id of a user is and just stream the already listened to org collection
                 * watch function and set the org accordingly based on active id at that time
                 *
                 */

                // if (userCollectionData.role === 'resi') {
                //     if (userCollectionData.active_property_id) {
                //         yield fork(propertyCollectionWatch, {
                //             ////////////////////// Live Listener //////////////////////
                //             propertyId: userCollectionData.active_property_id
                //         });
                //     }

                //     yield fork(listenToAccessKeysAndGuestInvites); ////////////////////// Live Listener //////////////////////

                //     return;
                // }

                // if (userCollectionData.type === 'super_admin') {
                //     yield fork(listenToCaPanels);
                //     yield fork(getRtdbCaPanels, userCollectionData);
                // }

                // if (
                //     userCollectionData.role === 'operator' &&
                //     userCollectionData.type !== 'super_admin'
                // ) {
                //     yield fork(getOrgKiosks, userCollectionData);
                //     yield fork(getRtdbCaPanels, userCollectionData);

                /*****************/ /////////////////////////////////////////////////////////////////*****************/
                // console.log(
                //     'im occcuurrrriinnngggg milos',
                //     userCollectionData.active_org_id
                // );
                // yield fork(usersActiveOrgCollectionWatch, userCollectionData); ////////////////////// Live Listener //////////////////////
                // yield put(
                //     settingActivePermissions({
                //         activePermissions:
                //             userCollectionData.orgs[userCollectionData.active_org_id]
                //                 ?.permissions
                //     })
                // );
                /*****************/ /////////////////////////////////////////////////////////////////*****************/
                // }

                // yield fork(fetchDeviceTypes); // device type list ////////////////////// Live Listener //////////////////////

                // if (userCollectionData?.twilio) {
                //     if (checkExpiration(userCollectionData.twilio.updated_at.seconds)) {
                //         refreshTwilioToken({ userId: userCollectionData.uid });
                //     }
                // }
                // // yield fork(userCollectionData);
                // // if (userCollectionData.type === 'super_admin') {
                // if (userCollectionData.role !== userRoles.GUEST) {
                //     yield fork(orgCollectionWatch, userCollectionData); // org list ////////////////////// Live Listener //////////////////////
                //     yield fork(activeOrgCollectionWatch, {
                //         ////////////////////// Live Listener //////////////////////
                //         payload: {
                //             id: userCollectionData.active_org_id,
                //             userType: userCollectionData.type
                //         }
                //     }); // org community data
                // }

                // yield fork(
                //     activeOrgCollectionWatch,
                //     userCollectionData.type === userTypes.SUPER_ADMIN
                //         ? userCollectionData.primary_org
                //         : userCollectionData.active_org_id
                // ); // org community data

                // if (
                //     (userCollectionData?.active_station_id ||
                //         userCollectionData.type === 'virtual_guard') &&
                //     userCollectionData.type !== 'super_admin' &&
                //     userCollectionData.role !== userRoles.GUEST
                // ) {
                //     yield fork(callsCollectionWatch, userCollectionData);
                //     yield fork(intercomCollectionWatch, userCollectionData);
                // }
                // yield fork(reservationsCollectionWatch, {
                //     ////////////////////// Live Listener //////////////////////
                //     payload: userCollectionData.active_org_id
                //         ? userCollectionData.active_org_id
                //         : userCollectionData.primary_org
                // });
                // yield fork(reservationsCollectionWatch, {
                //     payload: userCollectionData.active_org_id
                //         ? userCollectionData.active_org_id
                //         : userCollectionData.primary_org
                // });
                // yield fork(panelCollectionWatch, userCollectionData); // admin panel data aggregate doc
                // }
            }
        }
    } catch (error) {
        log('User Error: getting user collection data (FS)', {
            error,
            user
        });
    } finally {
        unsubcscribeUserCollectionData(); // Detach firebase listener
        if (yield cancelled()) {
            userCollectionChannel.close(); // Detach saga event emitter
            unsubcscribeUserCollectionData(); // Detach firebase listener
        }
    }
}

///////////// Action Creators For Root Saga //////////////////

export function* getUserCollection() {
    yield takeLatest(GET_USER_COLLECTION, userCollectionWatch);
}

export default function* rootSaga() {
    yield all([fork(getUserCollection)]);
}
